<template>
  <b-modal
    id="modal-remanejar-servico"
		title="Remanejar"
		centered
		size="lg"
		:hide-footer="true"
  >
    <div class="row" v-if="loading">
			<h1 class="col-12 text-center">{{ msg }}</h1>
			<load mode="table" />
		</div>
		<div v-else>
      <div class="row px-3" v-if="tecnicos.length > 0">
				<form-input-group
					class="px-0"
					type="search"
					v-model="search"
					btn-class="btn input-group-text border-left-0 p-2 bg-white"
					icon-btn="mdi mdi-magnify mdi-18px"
					placeholder="Filtrar pelo técnico"
				/>
			</div>
      <div class="table-tecnicos col-12" v-if="tecnicos.length > 0">
        <table class="b-table table table-striped table-sm b-table-stacked-md">
          <thead>
            <tr>
              <th></th>
              <th>Nome</th>
              <th>Unidade</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tecnico in filtrarResultados" :key="tecnico.id">
              <td>
                <input
                  type="radio"
                  :id="tecnico.id"
                  :value="tecnico.id"
                  v-model="novo_responsavel"
                />
              </td>
              <td>
                  <strong>{{ tecnico.value }}</strong> - <span> {{ tecnico.profissao ?? 'Não informado' }} </span>
              </td>
              <td>
                <span>
                  {{ tecnico.nome_unidade }} 
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h2 class="text-warning">
          <i class="mdi mdi-24px mdi-alert-decagram-outline"></i> Nada foi encontrado.
        </h2>
      </div>
    </div>
    <div class="row pt-1 px-2 d-flex justify-content-end">
      <button
        v-if="novo_responsavel"
        @click="submit"
        class="btn btn-success btn-submit"
      >
        Remanejar
      </button>
      <button class="btn btn-danger" @click="cancelar">
        <i class="mdi mdi-close"></i> Fechar
      </button>
    </div>
  </b-modal> 
</template>

<script>
  export default {
    props: ['servico','servico_id','tecnico_id'],
    data() {
      return {
        loading: true,
        novo_responsavel: "",
        tecnicos: [],
        msg: "Buscando técnicos.",
        search: '',
      };
    },
    watch: {
      tecnico_id() {
        this.getTecnicos();
      },
    },
    mounted() { // programassociais so funciona com o mounted
      this.getTecnicos();
    },
    computed: {
      filtrarResultados() {
        if (this.search != "") {
          return this.tecnicos.filter((item) => {
            const nome = item.value.toLowerCase();
            const unidade = item.nome_unidade.toLowerCase();
            const busca = this.search.toLowerCase();
            const tecnico = nome.includes(busca);
            if (tecnico) {
              return item;
            } else {
              return unidade.includes(busca) ? item : false;
            }
          });
        } else {
          return this.tecnicos;
        }
      },
    },
    methods: {
      getTecnicos(){
        this.loading = true;
        if(!this.tecnico_id) return null;
        axios
          //.get(`api/dashboard/atendimento/exclude/tecnicos/${this.tecnico_id}`)
          .get(`api/dashboard/atividades/tecnicos/get`)
          .then((response) => {
            this.tecnicos = response.data;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      submit() {
        this.loading = true;
				this.msg = "Remanejando";
        var url = `api/dashboard/${this.servico}/remanejar`;
				axios
					.post(url, {
						id: this.servico_id,
						user: this.novo_responsavel,
					})
					.then((response) => {
						swal.fire({
							text: "Remanejado com sucesso.",
							icon: "success",
							showConfirmButton: false,
							timer: 3000,
						});
						this.loading = false;
            this.$router.go(-1);
						//this.$router.push(`/dashboard/${this.servico}/edit/${this.item.id}`);
            //this.$emit("limpar");
            this.$bvModal.hide("modal-remanejar-servico");
					})
					.catch((error) => {
						swal.fire({
							text: "Não foi possível remanejar para o técnico selecionado.",
							icon: "error",
							showConfirmButton: false,
							timer: 3000,
						});
						this.loading = false;
					});
      },
      cancelar() {
        Object.assign(this.$data, this.$options.data.call(this));
        this.$bvModal.hide("modal-remanejar-servico");
      },
    }
  }
</script>
